import type { ManualIncentiveEditEntry } from '@makemydeal/dr-platform-types';
import type { IncentiveFieldDisplayNames } from './types';

export const OPTIONAL_INDICATOR = 'optional';
export const CODE = 'Code';
export const TYPE = 'Type';
export const INCENTIVE_DUPLICATE_CODE = 'Duplicate code';
export const INCENTIVES = 'Incentives';
export const REQUIRED = 'required';
export const REQUIRED_FIELD_MESSAGE = 'Field is required';
export const ADD_INCENTIVE_BUTTON = '+ Add Incentive';

export const INCENTIVE_FIELD_NAMES = {
    NAME: 'name',
    CODE: 'code',
    TYPE: 'type',
    AMOUNT: 'amount',
    PROGRAM: 'program'
} as const;
export const ERROR_MESSAGE = 'No Incentives Found';
export const NO_DATA_EXIST_MESSAGE = 'No Incentives to display';
export const EXCLUSION_MESSAGE = 'Incentive unavailable with current selections';
export const buildExclusionMessage = (blockingIncentiveName?: string): string =>
    blockingIncentiveName ? `Not available with ${blockingIncentiveName}` : EXCLUSION_MESSAGE;
export const ZERO_AMOUNT_MESSAGE = 'No cash amount on this program';
export const PROGRAM_LOSS_MESSAGE = 'Not available with the selected program';
export const REQUIRED_FIELDS: (keyof ManualIncentiveEditEntry)[] = ['name', 'type'];
export const PAYMENT_FIELDS = ['type', 'amount', 'code', 'name'];
export const FIELD_DISPLAY_NAMES: IncentiveFieldDisplayNames = {
    name: 'Incentive Name',
    type: 'Type',
    amount: 'Amount'
};
export const INCENTIVE_NOT_EDITED = -1;
export const INCENTIVE_MODIFICATION_ACTION = {
    ADD: 'add',
    REMOVE: 'remove',
    EDIT: 'edit'
} as const;
